import { useContext } from 'react';
import { buildConfigContext } from './build-config-context';

export function useBuildConfig() {
  const buildConfig = useContext(buildConfigContext);
  if (!buildConfig) {
    throw new Error(
      'buildConfigContext value is undefined. Make sure you use the BuildConfigProvider before using the context.'
    );
  }
  return buildConfig;
}

export function useBuildVars() {
  return useBuildConfig().vars;
}

/** @deprecated */
export function useMfOutlets() {
  return useBuildConfig().mfOutlets;
}
